import React from 'react';
import { useTranslation } from 'react-i18next';
import './Loading.css';

/**
 * Centered loading indicator: a spinning ring in the brand color with an
 * optional label below. Replaces the bare "Loading…" text most pages used
 * to render while waiting on data.
 *
 * Props:
 *   - label     custom text below the spinner (defaults to t('loading'))
 *   - showLabel set to false to render the ring on its own
 *   - size      'sm' | 'md' (default) | 'lg'
 *   - inline    when true, doesn't take full width / extra padding
 */
const Loading = ({
  label,
  showLabel = true,
  size = 'md',
  inline = false,
  className = '',
}) => {
  const { t } = useTranslation();
  const text = label ?? t('loading');

  return (
    <div className={`tn-loading tn-loading--${size} ${inline ? 'tn-loading--inline' : ''} ${className}`}>
      <span className="tn-loading__ring" aria-hidden="true" />
      {showLabel && <span className="tn-loading__label">{text}</span>}
    </div>
  );
};

export default Loading;
